import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GoogleSsoConfig } from '@rubii/share/src/classes/data-source-config';

export interface GoogleSsoConfigDialogData {
  payload: GoogleSsoConfig;
  domain: string;
}

@Component({
  selector: 'app-google-sso-config',
  templateUrl: './google-sso-config.component.html',
  styleUrls: ['./google-sso-config.component.scss']
})
export class GoogleSsoConfigComponent implements OnInit {
  payload: GoogleSsoConfig;
  domain: string;

  constructor(
    public dialogRef: MatDialogRef<GoogleSsoConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GoogleSsoConfigDialogData
  ) {
    this.payload = data.payload;
    this.domain = data.domain;
  }

  ngOnInit(): void {
  }
}
